import React from 'react'
import NextPageService from '../services/nextpage.service'
import NpDropdown from '../components/dropdown'

export type ISelectProps = {
  selectList: any[],
  nextPage?: NextPageService,
  autoSize?: boolean
}

interface ISelectState {
  value: string
}

let options: JSX.Element[] = []

class NpSelect extends React.Component<ISelectProps, ISelectState> {

  constructor(props: ISelectProps) {
    super(props);
    this.state = {value: props.selectList[0]};

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);

    options = props.selectList.map((sl, i) => (
      <option key={i} value={sl} role='option' className={`panel-heading ${i === 0 ? 'aria-selected' : ''}`} onChange={this.handleClick}>
        {sl}
      </option>
    ))

  }

  handleChange(event: React.FormEvent<HTMLSelectElement> | React.FormEvent<HTMLButtonElement>) {
    this.setState({value: event.currentTarget.value});
  }

  handleClick(event: React.FormEvent<HTMLOptionElement>) {
    this.setState({value: event.currentTarget.textContent as string})
  }

  render() {

    return (this.props.selectList.length > 0 &&
      <React.Fragment>
        <NpDropdown dropdownList={this.props.selectList} clickHandler={(event: any) => {this.handleClick(event)}} selectDropdown={true}></NpDropdown>
        <select className="branded" value={this.state.value} onChange={this.handleChange}>
          {options}
        </select>
      </React.Fragment>
      
    );
  }
}

export default NpSelect